import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { DesktopNavigation } from './DesktopNavigation';
import { MobileNavigation } from './MobileNavigation';
import media from '../../utils/media';
import { isExperienceEditor } from '../../utils/experience-editor';
const OuterContainer = styled.header `
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${({ theme }) => theme.primaryWhite};
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2);
  z-index: 99;
  box-sizing: border-box;

  ${media.tablet} {
    box-shadow: none;
    border-bottom: 1px solid ${({ theme }) => theme.greyDarkMedium};
  }

  ${({ isInExperienceEditor }) => isInExperienceEditor &&
    css `
      position: relative !important;
      top: 0 !important;
    `}
`;
export const NavigationLayout = ({ fields, params }) => {
    if (!fields || !fields.items || fields.items.length < 1) {
        return null;
    }
    // TODO: remove this state and have a window check in isExperienceEditor
    const [isInExperienceEditor, setIsInExperienceEditor] = useState(false);
    const currentSite = params['currentSite'].replace(/\s+/g, '-');
    const siteOwner = params['siteOwner'];
    const currentLanguage = params['currentLanguage'] || 'en';
    const siteLogo = params.siteLogo;
    const { items } = fields;
    useEffect(() => {
        if (typeof window !== 'undefined' && isExperienceEditor()) {
            setIsInExperienceEditor(true);
        }
    }, []);
    return (React.createElement(OuterContainer, { isInExperienceEditor: isInExperienceEditor },
        React.createElement(DesktopNavigation, { currentLanguage: currentLanguage, navigationItems: items, siteLogo: siteLogo, currentSite: currentSite, siteOwner: siteOwner, languageToggleOptions: params.languageToggleOptions }),
        React.createElement(MobileNavigation, { currentLanguage: currentLanguage, navigationItems: items, siteLogo: siteLogo, currentSite: currentSite, siteOwner: siteOwner, languageToggleOptions: params.languageToggleOptions })));
};
